var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteFriendsCircleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 13.627a3.562 3.562 0 01-.84-3.113 3.522 3.522 0 00-2.373-4.106 3.572 3.572 0 01-2.285-2.285 3.533 3.533 0 00-4.106-2.374 3.49 3.49 0 01-3.113-.838 3.548 3.548 0 00-4.746 0 3.563 3.563 0 01-3.113.838 3.522 3.522 0 00-4.106 2.374 3.571 3.571 0 01-2.285 2.285 3.534 3.534 0 00-2.374 4.106 3.49 3.49 0 01-.838 3.113 3.548 3.548 0 000 4.746 3.563 3.563 0 01.838 3.113 3.522 3.522 0 002.374 4.106 3.573 3.573 0 012.285 2.285 3.533 3.533 0 004.106 2.374 3.49 3.49 0 013.113.838 3.548 3.548 0 004.746 0 3.562 3.562 0 013.113-.838 3.522 3.522 0 004.106-2.374 3.573 3.573 0 012.285-2.285 3.534 3.534 0 002.374-4.106 3.49 3.49 0 01.838-3.113 3.548 3.548 0 000-4.746z",
    fill: "url(#invite-friends-circle-small_svg__paint0_linear_677_8168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "invite-friends-circle-small_svg__paint0_linear_677_8168",
    x1: 5.632,
    y1: 6.016,
    x2: 26.624,
    y2: 26.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D78DB"
  })))));
}
export default SvgInviteFriendsCircleSmall;